// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import './i18n';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import App from './App';
import { unregister } from './registerServiceWorker';

import NewRelicConfiguration from './Lib/new-relic-configuration';

// The agent loader code executes immediately on instantiation.
const agent = new BrowserAgent(NewRelicConfiguration(window.location.hostname));

agent.addRelease('MJN-EmployersDashboard', process.env.REACT_APP_VERSION);
agent.setApplicationVersion(process.env.REACT_APP_VERSION);

const domRoot = document.getElementById('root');
if (domRoot === null) {
  throw new Error('no root element found');
} else {
  ReactDOM.render(
    <Router>
      <App />
    </Router>,
    domRoot,
  );
  unregister();
}
